// extracted by mini-css-extract-plugin
module.exports = {"activity":"_2l3hHVkIkeJo_gmRsTzMmN","symbol":"_14w2q8Ghcdxe4lPgQGq5WI"};